import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { useAuth } from 'src/utils/auth';
import CLIENT_INFO from 'src/graphql/query/user-info.graphql';

import type { ClientInformation } from 'src/types/client';

const useUser = () => {
  const auth = useAuth();
  const { loading, error, data, refetch } = useQuery(CLIENT_INFO, {
    skip: !auth.clientId,
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
  });

  const user = useMemo(
    () => (data?.user as ClientInformation) ?? {},
    [data?.user]
  );

  // TODO: Update once BE changed this
  const hasLadLibrarySearch =
    user?.metadata?.find((d: any) => d.definition.key === 'lad_library_search')
      ?.value ?? false;

  return {
    loading,
    error,
    user: {
      ...user,
      institutionId: user?.institution?.institutionId,
      institutionName: user?.institution?.name,
      programId: user?.program?.programId,
      programName: user?.program?.name,
      campusId: user?.campus?.campusId,
      campusName: user?.campus?.name,
      classId: user?.class?.classId,
      className: user?.class?.name,
      hasLadLibrarySearch,
      isFacultyCustomer: user?.professor?.isCustomer ?? false,
    },
    refetch,
  };
};

export default useUser;
